import { render } from "./WorkloadPreApproveDialog.vue?vue&type=template&id=a66c398e&scoped=true"
import script from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"

import "./WorkloadPreApproveDialog.vue?vue&type=style&index=0&id=a66c398e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66c398e"]])

export default __exports__